import type { User } from 'firebase/auth';

import { FIRESTORE_ENABLED } from '@/config/env';
import { firebaseApp } from '@/lib/firebase';
import { signOut, updateToken } from './session';


export async function endFirebaseSession(): Promise<void> {
  if (!FIRESTORE_ENABLED) return;
  const { getAuth, signOut: endSession } = await import('firebase/auth');
  await endSession(getAuth(firebaseApp()));
}

async function applyFirebaseUser(user: User | null): Promise<void> {
  if (!user) {
    signOut('expired');
    return;
  }
  try {
    updateToken(await user.getIdToken());
  } catch {
    signOut('expired');
  }
}


export async function watchFirebaseSession(): Promise<void> {
  if (!FIRESTORE_ENABLED) return;

  const { getAuth, onIdTokenChanged } = await import('firebase/auth');

  await new Promise<void>((resolve) => {
    onIdTokenChanged(getAuth(firebaseApp()), (user) => {
      void applyFirebaseUser(user).finally(resolve);
    });
  });
}
